import type { SubscriptionProductBase } from '../storage/payment-processing'

const now = Date.now()
export const CURRENT_DEFAULT_PLAN = 'launch-price'

export const DEFAULT_PLANS: Record<string, SubscriptionProductBase> = {
    'launch-price': {
        id: 'launch-price',
        lemonsqueezyProductId: 642917,
        createdAt: now,
        updatedAt: now,
        variants: [
            {
                id: 'free',
                title: 'Free',
                lemonsqueezyProductId: 1009170,
                limits: {
                    maxInvoicesIngested: 50,
                },
                price: 0,
            },
            {
                id: '400',
                title: '400 Invoices',
                lemonsqueezyProductId: 1009131,
                limits: {
                    maxInvoicesIngested: 400,
                },
                price: 50,
            },
            {
                id: '1000',
                title: '1000 Invoices',
                lemonsqueezyProductId: 1009166,
                limits: {
                    maxInvoicesIngested: 1000,
                },
                price: 100,
            },
            {
                id: '2000',
                title: '2000 Invoices',
                lemonsqueezyProductId: 1009167,
                limits: {
                    maxInvoicesIngested: 2000,
                },
                price: 180,
            },
            // {
            //     id: '2000',
            //     title: '2000 Invoices',
            //     lemonsqueezyProductId: 1009168,
            //     limits: {
            //         maxInvoicesIngested: 2000,
            //     },
            //     price: 300,
            // },
            // {
            //     id: '5000',
            //     title: '5000 Invoices',
            //     lemonsqueezyProductId: 1009169,
            //     limits: {
            //         maxInvoicesIngested: 5000,
            //     },
            //     price: 700,
            // },
            {
                id: 'lifetime',
                title: 'Lifetime',
                lemonsqueezyProductId: 1009175,
                limits: {
                    maxInvoicesIngested: 500000,
                },
                price: 250,
            },
        ],
    },
}

export const DEFAULT_PLANS_PROD: Record<string, SubscriptionProductBase> = {
    'launch-price': {
        id: 'launch-price',
        lemonsqueezyProductId: 642941,
        createdAt: now,
        updatedAt: now,
        variants: [
            {
                id: 'free',
                title: 'Free',
                lemonsqueezyProductId: 1009179,
                limits: {
                    maxInvoicesIngested: 50,
                },
                price: 0,
            },
            {
                id: '200',
                title: '200 Invoices',
                lemonsqueezyProductId: 1009180,
                limits: {
                    maxInvoicesIngested: 400,
                },
                price: 50,
            },
            {
                id: '500',
                title: '500 Invoices',
                lemonsqueezyProductId: 1009182,
                limits: {
                    maxInvoicesIngested: 1000,
                },
                price: 100,
            },
            {
                id: '1000',
                title: '1000 Invoices',
                lemonsqueezyProductId: 1009183,
                limits: {
                    maxInvoicesIngested: 2000,
                },
                price: 180,
            },
            // {
            //     id: '2000',
            //     title: '2000 Invoices',
            //     lemonsqueezyProductId: 1009184,
            //     limits: {
            //         maxInvoicesIngested: 2000,
            //     },
            //     price: 300,
            // },
            // {
            //     id: '5000',
            //     title: '5000 Invoices',
            //     lemonsqueezyProductId: 1009185,
            //     limits: {
            //         maxInvoicesIngested: 5000,
            //     },
            //     price: 700,
            // },
            {
                id: 'lifetime',
                title: 'Lifetime',
                lemonsqueezyProductId: 1009181,
                limits: {
                    maxInvoicesIngested: 500000,
                },
                price: 250,
            },
        ],
    },
}
